<template>
  <div>
    <QueryFrame
      :disablePage="true"
      :add-text="handlePermission('insuranceCardPwdUpdate') ? '修改卡密码' : ''"
      @addNew="handleCardPwd">
    </QueryFrame>
  </div>
</template>
<script>
import QueryFrame from '../../../components/frame/QueryFrame.vue';
import utils from '../../../libs/utils';
import insurance from '../../../services/insurance';
import mapState from '../../../mixins/mapState'; // 鉴权
import queryMixins from '../../../mixins/queryMixins';

export default {
  name: 'InsuranceCardUpdatedList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  computed: {},
  data() {
    return {};
  },
  methods: {
    handleCardPwd() {
      this.$store.commit('setDisableLoading', true);
      insurance.insuranceCardUpdatedPwd().then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('密码修改成功');
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
  },
};
</script>
<style lang="less" scoped>
</style>
